import React from 'react'
import Home from './Home'

export default function Analytics(): React.ReactElement {
  return <Home mode='analytics' />
}
